// src/components/DataChart.js
import React, { useEffect, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler
} from 'chart.js';
import { Paper, Typography, Box } from '@mui/material';

ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler
);

function DataChart({ chartData, siteName, selectedDate }) {
  const chartRef = useRef(null);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: false, // Though areas are stacked, x-axis itself isn't typically "stacked"
        title: {
          display: true,
          text: 'Time of Day (hourly intervals)'
        },
        ticks: {
          maxTicksLimit: 12 // Show fewer labels for readability
        }
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Vermogen (kW)'
        },
        beginAtZero: false // Allow negative values for "capacity to sell"
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: chartData && chartData.datasets && chartData.datasets.length > 0 ? 
              `Power Simulation for ${siteName || 'Selected Sites'} on ${selectedDate || 'Selected Date'}` :
              'Select sites and a date, then click Simulate',
        font: { size: 16 }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
  };
  
  // Default empty chart structure
  const emptyData = {
    labels: [],
    datasets: []
  };

  return (
    <Paper elevation={3} sx={{ p: 2, height: '600px' }}>
       <Typography variant="h6" gutterBottom>Simulation Chart</Typography>
      <Box sx={{ height: 'calc(100% - 40px)'}}> {/* Adjust height based on Typography */}
        <Line ref={chartRef} options={options} data={chartData && chartData.labels ? chartData : emptyData} />
      </Box>
    </Paper>
  );
}

export default DataChart;